/*
 * Size pickers on product cards inside a looped Swiper slider.
 *
 * Swiper 8 with `loop: true` clones slides, so a cloned card keeps the element
 * ids and the radio group names of the original card. Two things break:
 *   - <label for="..."> of one copy points at the radio of the other copy, so
 *     clicking a size highlights nothing in the card that was clicked;
 *   - both copies share one radio group, so only one of them can keep the size
 *     that Liquid pre-selected, and the other card renders with no size marked.
 *
 * Every cloned slide gets its own suffix for the variant radio ids and names,
 * and the selected size is restored per card. It re-runs whenever the slider
 * changes: Swiper re-creates the clones on resize, and a card replaces its own
 * variant picker with freshly rendered markup after a size is chosen.
 */
(function () {
  'use strict';

  var REF_ATTRS = ['aria-controls', 'aria-describedby', 'aria-labelledby'];

  function endsWith(value, suffix) {
    return typeof value === 'string' && value.slice(-suffix.length) === suffix;
  }

  function fixSlide(slide) {
    var suffix = slide.dataset.variantDupSuffix;
    if (!suffix) {
      // window-level counter: the same section can be on the page twice
      window.cardSliderVariantCounter = (window.cardSliderVariantCounter || 0) + 1;
      suffix = '-dup' + window.cardSliderVariantCounter;
      slide.dataset.variantDupSuffix = suffix;
    }

    var map = {};
    var renamed = false;

    slide.querySelectorAll('variant-selects input[type="radio"][id]').forEach(function (input) {
      if (endsWith(input.id, suffix)) return;
      map[input.id] = input.id + suffix;
      input.id += suffix;
      if (input.name && !endsWith(input.name, suffix)) input.name += suffix;
      renamed = true;
    });

    if (!renamed) return;

    slide.querySelectorAll('variant-selects [for]').forEach(function (element) {
      var value = element.getAttribute('for');
      if (map[value]) element.setAttribute('for', map[value]);
    });

    REF_ATTRS.forEach(function (attribute) {
      slide.querySelectorAll('variant-selects [' + attribute + ']').forEach(function (element) {
        var value = element.getAttribute(attribute);
        if (map[value]) element.setAttribute(attribute, map[value]);
      });
    });
  }

  function restoreSelected(root) {
    var groups = {};

    root.querySelectorAll('variant-selects input[type="radio"]').forEach(function (input) {
      var picker = input.closest('variant-selects');
      var key = (picker ? picker.id : '') + '|' + input.name;
      if (!groups[key]) groups[key] = [];
      groups[key].push(input);
    });

    Object.keys(groups).forEach(function (key) {
      var inputs = groups[key];
      var hasSelection = inputs.some(function (input) {
        return input.checked;
      });
      if (hasSelection) return;

      var restore =
        inputs.filter(function (input) {
          return input.dataset.userSelected === 'true';
        })[0] ||
        inputs.filter(function (input) {
          return input.hasAttribute('checked');
        })[0];

      if (restore) restore.checked = true;
    });
  }

  function run(root) {
    root.querySelectorAll('.swiper-slide-duplicate').forEach(fixSlide);
    restoreSelected(root);
  }

  function rememberSelection(event) {
    var input = event.target;
    if (!input || input.type !== 'radio') return;

    var picker = input.closest('variant-selects');
    if (!picker) return;

    picker.querySelectorAll('input[type="radio"]').forEach(function (other) {
      if (other.name === input.name) delete other.dataset.userSelected;
    });
    input.dataset.userSelected = 'true';
  }

  function init() {
    document.querySelectorAll('.swiper').forEach(function (root) {
      if (root.dataset.variantDupFix || !root.querySelector('variant-selects')) return;
      root.dataset.variantDupFix = 'true';

      run(root);
      root.addEventListener('change', rememberSelection, true);

      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          run(root);
        }, 50);
      }).observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.initCardSliderVariants = init;
})();
